import axiosService from '../services/axiosService';
import { DOMAIN } from 'constants';

export const getShortVideoDetail = id => {
  return axiosService.get(`${DOMAIN}/api/v2/short_video/short_videos/${id}`);
};
